<template>
    <router-view />
</template>

<style>
 @import "./assets/css/templatemo-edu-meeting.css";
</style>
